var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.orderId)?_c('div',{staticClass:"qr notranslate"},[_c('div',{staticClass:"mt30"},[_vm._v(_vm._s(_vm.locale.reservation_check_qrcode))]),(_vm.value)?_c('vue-qrcode',{attrs:{"value":_vm.value,"scale":_vm.scale || 6}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }